import { matchRoutePath } from '../../../../../shared/frontend/libs/router/router-helpers';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_CHARACTER_DETAILS,
  SET_CHARACTER_ALTS,
  REDIRECT_TO_CHARACTER_PAGE,
  SET_CHARACTER_LOADOUT_LOADING
} from '../actions/characterActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';
import { namedRoutes } from '../bundles/routes';

export default function characterDetails(
  state: Partial<TCharacterDetailsClientState> = {},
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case REDIRECT_TO_CHARACTER_PAGE: {
      return {
        ...state,
        redirectCharacter: action.payload
      };
    }
    case SET_CHARACTER_DETAILS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SET_CHARACTER_ALTS: {
      return {
        ...state,
        alts: action.payload
      };
    }
    case SET_CHARACTER_LOADOUT_LOADING: {
      return {
        ...state,
        isLoadoutLoading: action.payload
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }

      const match = matchRoutePath(
        {
          path: namedRoutes.CharacterDetails,
          end: false
        },
        action.payload.location.pathname
      );

      if (
        match &&
        state.character &&
        state.character.region.slug === match.params.region &&
        state.character.realm.slug === match.params.realm &&
        state.character.name === match.params.character
        // state.character.name.normalize('NFC') === decodeURIComponent(match.params.character || '').normalize('NFC')
      ) {
        return state;
      }

      return {};
    }
    default: {
      return state;
    }
  }
}
